import React from 'react';
import MediaQueries from 'react-responsive';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Align from '@marvelapp/marvel-ui/align';

import ContactForm from 'marketing-website/components/modules/ContactForm';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import HeroIllustration from 'marketing-website/components/modules/Hero/HeroIllustration';
import Image from 'marketing-website/components/modules/Image';
import MediaSingleImage from 'marketing-website/components/modules/Media/MediaSingleImage';
import OffsetBackground from 'marketing-website/components/wrappers/OffsetBackground';
import Page from 'marketing-website/components/modules/Page';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Whitespace from 'marketing-website/components/commons/Whitespace';

import ArrowLink from 'marketing-website/components/commons/ArrowLink';
import assets from 'marketing-website/configs/pages/contact-us/assets.js';
import { formContactUs } from 'marketing-website/configs/hubspot';
import metaData from 'marketing-website/data/metadata.js';

import ContactCard from './ContactCard';

const supportLinks = [
  {
    image: assets.sales,
    title: 'Sales',
    copy: 'For purchasing Marvel Enterprise and multi-year plans',
    url: 'mailto:sales@marvelapp.com',
  },
  {
    copy: 'Need help with Marvel? Report issues and ask questions here',
    image: assets.support,
    title: 'Support',
    url: 'https://help.marvelapp.com/hc/en-us/requests/new',
  },
  {
    copy: 'Download our brand pack including logos and product shots',
    image: assets.press,
    title: 'Press Kit',
    url:
      'https://www.dropbox.com/sh/nzv8j2bvjgi9jzz/AAB8jc2jQRRg022GqJKhPJOma?dl=0',
  },
];

const url =
  "https://www.google.com/maps/place/7-10+Bateman's+Row,+Hackney,+London+EC2A+3HH/data=!4m2!3m1!1s0x48761cb08076337b:0xfac604bd39278c8b?sa=X&ved=2ahUKEwi50bf73vPmAhVFnVwKHYeeA74Q8gEwAHoECAsQAQ";

export default function ContactUs() {
  const title = <div>How to find Marvel HQ</div>;
  const headingCopy = 'Drop us a line';
  return (
    <Page
      title={metaData['contact-us'].title}
      meta={[
        { name: 'description', content: metaData['contact-us'].description },
        { name: 'keywords', content: metaData['contact-us'].keywords },
      ]}
      header
      footer
    >
      <Spacing type="padding" size="l" position="topBottom">
        <MediaQueries maxWidth={769}>
          <PageWrap>
            <Align type="center">
              <Spacing type="padding" size="l">
                <Image {...assets.illustration} hasShadow={false} />
              </Spacing>
              <Heading tag="h2" size="xxxxl" weight="semibold">
                {headingCopy}
              </Heading>
            </Align>
            <ContactForm hubspotId={formContactUs} />
          </PageWrap>
        </MediaQueries>

        <MediaQueries minWidth={770}>
          <HeroIllustration
            {...assets.illustration}
            imageMaxWidth={655}
            isContactUsPage
            headingMaxWidth={600}
            title={headingCopy}
            tag="h1"
          >
            <Spacing type="margin" position="topBottom" sizeM="l">
              <ContactForm hubspotId={formContactUs} />
            </Spacing>
          </HeroIllustration>
        </MediaQueries>

        <Spacing type="margin" size="0" sizeM="xl" position="topBottom">
          <Spacing type="padding" size="xl" sizeM="0" position="topBottom">
            <HeadingBlock
              title="Looking for something in particular?"
              alignContent="center"
            />
          </Spacing>
          <div className="bg-marvel breakPointM-bg-none">
            <OffsetBackground height={70}>
              <PageWrap size="l">
                <Spacing
                  type="padding"
                  size="l"
                  sizeM="xl"
                  position="topBottom"
                >
                  <ParallaxWrapper speed={1.4} positionAbsolute={false}>
                    <Grid columns={12}>
                      {/* eslint-disable no-shadow */
                      supportLinks.map(
                        ({ copy: linkCopy, image, title: linkTitle, url }) => (
                          <GridItem
                            columnSpan={12}
                            columnSpanM={4}
                            key={linkTitle}
                          >
                            <ContactCard
                              copy={linkCopy}
                              image={image}
                              imgUrl="#"
                              title={linkTitle}
                              url={url}
                            />
                          </GridItem>
                        )
                      )}
                    </Grid>
                  </ParallaxWrapper>
                </Spacing>
              </PageWrap>
            </OffsetBackground>
          </div>
        </Spacing>
        <Spacing type="padding" size="l" sizeM="xl" position="topBottom">
          <MediaSingleImage
            {...assets.office}
            justifyContent="center"
            reversed
            title={title}
            imageBorderRadius="none"
            hasShadow={false}
          >
            <Spacing type="padding" size="l" sizeM="xl" position="top">
              <Heading size="xl" weight="semibold">
                London
              </Heading>
              <Spacing type="margin" size="m" position="topBottom">
                <Paragraph size="m">{"7-10 Bateman's Row"}</Paragraph>
                <Paragraph size="m">London</Paragraph>
                <Paragraph size="m">EC2A 3HH</Paragraph>
              </Spacing>
              <MarvelLink url={url} target="_blank">
                <ArrowLink>Open in Google Maps</ArrowLink>
              </MarvelLink>
            </Spacing>
          </MediaSingleImage>
        </Spacing>
        <MediaQueries minWidth={770}>
          <Whitespace sizeM="l" />
        </MediaQueries>
      </Spacing>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/contact-us/index.js